import React, { Component } from 'react'

import classes from './SetupPositionGroup.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
// import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import Form from '../../../../components/PageContent/SetupData/SetupPositionGroup/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import ImportModal from '../../../../components/PageContent/AppraisalItem/ImportModal/ImportModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Checkbox } from '@material-ui/core'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class SetupPositionGroup extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    importModalOpen: false,
    importFile: null,
    action: 'add',
    addAno: false,
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    form: {
      position_group_code: {
        label: this.props.translate('positionGroupCode'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('positionGroupCode')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      position_group_name: {
        label: this.props.translate('positionGroupName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('positionGroupName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('selecct') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('selecct') + this.props.translate('company') }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      position_group_level_id: {
        label: this.props.translate('positionGroupLevel'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          options: []
        },
        value: null,
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      is_active: {
        label: this.props.translate('active'),
        elementType: 'checkbox',
        value: true,
        validation: false,
        valid: true
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('selecct') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('selecct') + this.props.translate('company') }
          ]
        }
      },
      position_group_id: {
        label: this.props.translate('positionGroupName'),
        value: '',
        configs: {
          placeholder: this.props.translate('selecct') + this.props.translate('positionGroupName'),
          options: [
            {
              value: '',
              label: this.props.translate('selecct') + this.props.translate('positionGroupName')
            }
          ]
        }
      },
      is_active: {
        label: this.props.translate('active'),
        value: '',
        configs: {
          placeholder: this.props.translate('selecct') + this.props.translate('active'),
          options: [
            { value: '1', label: 'Active' },
            { value: '0', label: 'Inactive' }
          ]
        }
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      filterCompany: this.props.filterCompany,
      filterPositionGroup: this.props.filterPositionGroup,
      filterActive: this.props.filterActive
    }
  }
  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('positionGroup'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('positionGroup'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.position_group_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('positionGroup'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.position_group_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    {
      field: 'position_group_code',
      title: this.props.translate('positionGroupCode'),
      type: 'string'
    },
    {
      field: 'position_group_name',
      title: this.props.translate('positionGroupName'),
      type: 'string'
    },
    { field: 'company_name', title: this.props.translate('company'), type: 'string' },
    {
      field: 'is_active',
      title: this.props.translate('active'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_active} disabled />
      },
      width: 100
    }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchPositionGroup()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state
    const updateOptions = (stateId, propsId, attr) => {
      const form = state.form
      const targetPositionGroupItem = form[stateId]
      let [attrId, attrName, attrPlaceHolder] = attr

      updatedState = updateObject(updatedState, {
        form: updateObject(form, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetPositionGroupItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr

      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            state.filterControls[stateId].value
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      ])
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.positionGroupLevelOptions !== updateProps.positionGroupLevelOptions) {
      updateOptions('position_group_level_id', 'positionGroupLevelOptions', [
        'value_list_id',
        { code: 'value_list_code', name: 'value_list_name' }
      ])
    }

    if (props.filterPositionGroup !== updateProps.filterPositionGroup) {
      updateFilter('position_group_id', 'filterPositionGroup', [
        'position_group_id',
        { code: 'position_group_code', name: 'position_group_name' }
      ])
    }
    if (props.filterActive !== updateProps.filterActive) {
      updateFilter('is_active', 'filterActive', ['active_code', 'active_name'])
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let newPositionGroupData = Object.entries(state.form).reduce(
        (positionGroupGroups, positionGroup) => {
          let [positionGroupKey, positionGroupAttrs] = positionGroup
          let value = ''
          let valid = false
          let touched = false
          let errorMessage = null
          if (positionGroupAttrs.elementType === 'checkbox') {
            value = false
          }
          if (!positionGroupAttrs.validation || !positionGroupAttrs.validation.required) {
            valid = true
          }
          if (props.selectedRecord && props.selectedRecord[positionGroupKey]) {
            value = props.selectedRecord[positionGroupKey]

            let { isValid, error } = checkValidity(
              value,
              positionGroupAttrs.validation,
              positionGroupAttrs.label
            )

            if (positionGroupAttrs.elementType === 'newselect') {
              value =
                state.form[positionGroupKey].elementConfig.options.find(
                  res => res.value === value
                ) || {}
            }
            if (positionGroupAttrs.elementType === 'checkbox') {
              value = !!value
            }
            valid = isValid
            errorMessage = error
          }

          const newPositionGroupAttrs = {
            ...positionGroupAttrs,
            value: value,
            valid: valid,
            error: errorMessage,
            touched: touched
          }

          return updateObject(positionGroupGroups, {
            [positionGroupKey]: { ...newPositionGroupAttrs }
          })
        },
        {}
      )
      updatedState = {
        ...updatedState,
        formValid: true,
        form: newPositionGroupData,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      }
    }
    return updatedState
  }

  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchPositionGroup(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchPositionGroup(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }

  clearInput = () => {
    let newFormData = Object.entries(this.state.form).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'is_active':
          newFormAttrs = {
            ...formAttrs,
            value: true
          }

          break

        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})
    this.setState({ form: newFormData })
  }
  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchPositionGroupById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }

  openModal = () => {
    this.clearInput()
    this.setState({
      modalOpen: true
    })
  }

  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false
      })
    }
  }
  clearModal = () => {
    this.clearInput()
    this.props.clearSelectedRecord()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        formValid: false,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        formValid: false,
        modalOpen: false
      })
    }
  }
  openImportModal = () => {
    this.setState({
      importModalOpen: true
    })
  }

  closeImportModal = () => {
    this.setState({
      importModalOpen: false,
      importFile: ''
    })
  }
  positionGroupSubmitHandler = type => {
    let positionGroupData = Object.entries(this.state.form).reduce(
      (positionGroupData, positionGroupEntry) => {
        let [positionGroupKey, positionGroupAttrs] = positionGroupEntry
        let value = ''
        if (positionGroupAttrs.elementType === 'newselect') {
          value = positionGroupAttrs.value?.value
        } else {
          value = positionGroupAttrs.value
        }
        return { ...positionGroupData, [positionGroupKey]: value }
      },
      {}
    )
    if (this.state.action === 'add') {
      this.props.createPositionGroup(
        { ...positionGroupData },
        getPageStatus(this.props.pagination, false)
      )
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updatePositionGroup(
        this.state.actionRecordId,
        { ...positionGroupData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }
  inputChangeHandler = (groupKey, positionGroupKey, event) => {
    const inputGroup = this.state.form
    const positionGroupItem = inputGroup[positionGroupKey]
    let inputValue = ''

    switch (positionGroupItem.elementType) {
      case 'newselect':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !positionGroupItem.value
        break
      default:
        inputValue = event.target.value
        break
    }

    if (positionGroupKey === 'appraisal_type_id') {
      this.props.fetchParentPositionGroupOptions(inputValue.value)
    }
    const { isValid, error } = checkValidity(
      inputValue,
      positionGroupItem.validation,
      positionGroupItem.label
    )

    const updatedPositionGroupItem = {
      ...positionGroupItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = updateObject(inputGroup, { [positionGroupKey]: updatedPositionGroupItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })

    this.setState({
      form: updateObject(this.state.form, { [positionGroupKey]: updatedPositionGroupItem }),
      formValid: formIsValid
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deletePositionGroup(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    if (itemKey === 'company_id') {
      this.props.fetchPositionGroupOptions({ company_id: filterValue?.value })
    }
    this.setState({
      filterControls: updateObject(this.state.filterControls, {
        [itemKey]: {
          ...filterItem,
          value: filterValue
        }
      }),
      filter: { ...this.state.filter, [itemKey]: filterValue?.value }
    })
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let param = { ...this.state.filter, page: 1, perPage: 10 }
    this.props.fetchPositionGroup(param)
    this.closeFilterModal()
  }

  render() {
    let positionGroupLabel = <Spinner />

    if (!this.props.loading) {
      positionGroupLabel = Object.entries(this.state.form).map((item, key) => {
        return (
          <Form
            key={key}
            form={item}
            inputChanged={(positionGroupKey, e) =>
              this.inputChangeHandler(key, positionGroupKey, e)
            }
            formValid={this.state.formIsValid}
          />
        )
      })
    }
    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.positionGroupSubmitHandler}
    //         disabled={!this.state.formValid}>
    //         {this.props.translate('save')}
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         {this.props.translate('cancel')}
    //       </Button>
    //     </span>
    //   </div>
    // )
    const footer = (
      <Footer
        save={() => this.positionGroupSubmitHandler('save')}
        another={() => this.positionGroupSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!validateForm(this.state.form)}
      />
    )
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <ImportModal
          open={this.state.importModalOpen}
          cancelled={this.closeImportModal}
          fileChanged={this.fileChangeHandler}
          fileSubmit={this.fileSubmitHandler}
          selectedFile={this.state.importFile}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={
            this.props.translate(this.state.action) + this.props.translate('positionGroupName')
          }
          backdropClicked={this.closeModal}
          footer={footer}>
          <div className={classes.ModalBody}>{positionGroupLabel}</div>
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('positionGroup')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingQueue.includes('record')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.positionGroup.pagination,
    data: state.positionGroup.records,
    loading: state.positionGroup.loading,
    filterLoading: state.positionGroup.filterLoading,
    success: state.positionGroup.success,
    companyOptions: state.positionGroup.company,
    positionGroupLevelOptions: state.positionGroup.positionGroupLevels,
    selectedRecord: state.positionGroup.selectedRecord,
    filterCompany: state.positionGroup.filterCompany,
    filterPositionGroup: state.positionGroup.filterPositionGroup,
    filterActive: state.positionGroup.filterActive,
    loadingQueue: state.positionGroup.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchPositionGroup: filterOptions => dispatch(actions.fetchPositionGroup(filterOptions)),
    fetchPositionGroupById: recordId => dispatch(actions.fetchPositionGroupById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedPositionGroupRecord()),
    createPositionGroup: (recordData, page) =>
      dispatch(actions.createPositionGroup(recordData, page)),
    updatePositionGroup: (recordId, recordData, page) =>
      dispatch(actions.updatePositionGroup(recordId, recordData, page)),
    deletePositionGroup: (recordId, page) => dispatch(actions.deletePositionGroup(recordId, page)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchPositionGroupLevelOptions())
    },
    fetchPositionGroupOptions: filter => dispatch(actions.fetchPositionGroupOptions(filter)),
    fetchFilter: filter => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchPositionGroupOptions())
      dispatch(actions.fetchPositionGroupFilterActive())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupPositionGroup))
